
































































































import { Component } from 'vue-property-decorator'
import { ListLabelMixins } from '@/Mixins/ListLabelMixins'
import Tabs from './components/Tabs.vue'
import Sort from './components/Sort.vue'
import List from './components/List.vue'
import DetailInfo from './components/DetailInfo.vue'
import ProductList from '@/components/ProductList/index.vue'
import { productSearch, hotSale, scenicList, scenicProductList } from '@/api/product'
import { adInfo } from '@/api/home'

@Component({
  name: 'Supermarket',
  components: {
    Tabs,
    Sort,
    List,
    ProductList,
    DetailInfo
  }
})
export default class Supermarket extends ListLabelMixins {
  private TabActive = 1 // 产品分类 1 每周推荐

  private treeId = -99 // 产品类目

  private adInfoList: Array<any> = []

  private page = 1

  private detailPage = 1

  private resultNum = 12

  private sizeAll = 0

  private detailSizeAll = 0

  // 当前页面是否是显示榜单：跳转链接指定打开的节日榜单栏不显示高亮
  // isCommissionTop佣金榜单 isFestivalPromo节日大促 isSalesTop销量榜单
  private isTop: any = ''

  private isDetail = false // 是否展示景区详情

  // 产品分类数据
  private tabList = [
    { id: 0, name: '节日大促产品', icon: '' },
    { id: 1, name: '每周推荐', icon: 'http://qnimg.zowoyoo.com/img/84826/1762336112541.png' },
    { id: 2, name: '热销产品', icon: 'http://qnimg.zowoyoo.com/img/84826/1762336141265.png' },
    { id: 3, name: '最新产品', icon: 'http://qnimg.zowoyoo.com/img/84826/1762336198192.png' },
    { id: 4, name: '产品总览', icon: 'http://qnimg.zowoyoo.com/img/84826/1762336213607.png' },
    { id: 7, name: '商品', icon: 'http://qnimg.zowoyoo.com/img/84826/1763623569005.png' },
    { id: 5, name: '港澳', icon: 'http://qnimg.zowoyoo.com/img/84826/1762336230536.png' },
    { id: 6, name: '海外', icon: 'http://qnimg.zowoyoo.com/img/84826/1762336247186.png' }
  ]

  private sortActive = 1 // 1 推荐值 2 销量 3 发布时间 4 利润

  private sortType = 1 // 排序方式 0升序 1 降序

  private areaId: number | string = '' // 城市

  private keyword = '' // 搜索关键字

  private listData: any[] = []

  private loading = false

  private scenicItem: any = {} // 单个景区详情

  private scenicProduct: any = [] // 景区的商品列表

  // 获取轮播图数据
  getAdInfo (): void {
    const params = {
      page: 0,
      resultNum: 11, // 当前页面使用6-10的数据
      areaId: this.areaId
    }
    adInfo(params)
      .then((res) => {
        if (res && res.length && res.length > 6) {
          this.adInfoList = res.slice(6, 11)
        }
      })
  }

  // 获取节日推荐按钮图片
  getTab (): void {
    const params = {
      page: 0,
      resultNum: 1
    }
    adInfo(params)
      .then((res) => {
        if (res && res.length) {
          const { img } = res[0]
          this.tabList[0].icon = img
        }
      })
  }

  // 获取数据，精选好货的数据需要多个接口获取
  getData () {
    if (this.TabActive === 0) {
      // 节日推荐
      this.getHotSale(this.isTop || 'isFestivalPromo')
    } else if (this.TabActive === 1) {
      // 每周推荐
      this.getProductSearch()
    } else if (this.TabActive === 2) {
      // 热销产品
      this.getScenic()
    } else {
      // 其余
      this.getHotSale()
    }
  }

  // 改变页面产品类型 港澳和海外可以指定地区参数customAreaId
  changeTabs (customAreaId?: number) {
    this.areaId = ''
    this.isTop = ''
    this.treeId = -99
    this.page = 1
    this.sizeAll = 0
    this.sortActive = 1
    this.sortType = 1
    if (this.TabActive === 3) {
      this.sortActive = 3
    }
    // 港澳默认地区：香港
    if (this.TabActive === 5) {
      this.areaId = customAreaId || 10072
    }
    // 海外默认地区：泰国 默认产品类目：门票
    if (this.TabActive === 6) {
      this.areaId = customAreaId || 810
      this.treeId = 0
    }
    this.getData()
  }

  // 获取产品列表, 10647 - 接口所有数据归类到：每周推荐
  getProductSearch (): void {
    this.loading = true
    const params = {
      autoCount: true,
      isSupmarket: 1,
      areaId: this.areaId,
      keyword: encodeURIComponent(this.keyword),
      page: this.page,
      resultNum: this.resultNum,
      treeId: this.treeId,
      sort: this.sortActive,
      sortType: this.sortType // 排序方式 0升序 1 降序
      // parentMchId: '2485469' // 广州智我优旅行社
    }
    productSearch(params)
      .then(res => {
        this.loading = false
        if (res) {
          this.sizeAll = res.sizeAll
          this.listData = res.results || []
        }
      })
  }

  // 获取热销产品, 10647-页面除了每周推荐和热销产品，其他分类的数据在这个接口获取
  // 最新展示 days 7
  getHotSale (key?: any) {
    this.loading = true
    const params = {
      areaId: this.areaId,
      autoCount: true,
      keywords: this.keyword,
      resultNum: this.resultNum,
      page: this.page,
      sort: this.sortActive,
      sortType: this.sortType, // 排序方式 0升序 1 降序
      treeId: this.treeId,
      days: this.TabActive === 3 ? 7 : '', // 最新产品才传7，获取7天内产品
      viewId: this.TabActive === 7 ? 'view_1736465' : '', // 导航栏 商品 选项才传，其他选项为空
      parentMchId: '2485469' // 广州智我优旅行社
    }
    if (key) {
      params[key] = 1
    }
    hotSale(params).then(res => {
      this.loading = false
      if (res) {
        this.sizeAll = res.sizeAll
        this.listData = res.results || []
      }
    })
  }

  // 获取景区列表
  getScenic () {
    this.loading = true
    const params = {
      autoCount: true,
      keyword: this.keyword,
      resultNum: this.resultNum,
      page: this.page,
      sort: 1,
      sortType: 1,
      state: -99
    }
    scenicList(params).then(res => {
      this.loading = false
      if (res) {
        this.sizeAll = res.sizeAll
        this.listData = res.results || []
      }
    })
  }

  // 获取景区产品列表
  getScenicProductList () {
    this.loading = true
    const params = {
      autoCount: true,
      resultNum: this.resultNum,
      page: this.detailPage,
      sort: this.sortActive,
      sortType: this.sortType, // 排序方式 0升序 1 降序
      treeId: this.treeId,
      parentMchId: '2485469',
      viewIds: this.scenicItem.viewIds
    }
    scenicProductList(params).then(res => {
      this.loading = false
      if (res) {
        this.detailSizeAll = res.sizeAll
        this.scenicProduct = res.results || []
      }
    }).catch(err => {
      this.loading = false
      console.log('log输出的内容：失败了', err)
    })
  }

  // 点击轮播图
  clickCarousel (item): void {
    if (!item.link) return
    if (/^https?/.test(item.link)) {
      window.open(item.link)
    } else {
      this.$router.push(item.link)
    }
  }

  // 切换分页
  currentChange (item): void {
    this.page = item
    const scrollWrapper: any = this.$refs.scrollWrapper
    scrollWrapper.scrollIntoView()
    this.getData()
  }

  // 景区详情产品列表切换分页
  detailCurrentChange (item): void {
    this.detailPage = item
    const scrollWrapper: any = this.$refs.scrollWrapper
    scrollWrapper.scrollIntoView()
    this.getScenicProductList()
  }

  // 搜索事件触发
  clickSearch (): void {
    if (this.loading) {
      this.$message({
        message: '数据加载中，请稍候...',
        type: 'warning'
      })
      return
    }
    this.getData()
  }

  // 切换城市
  changeCity (item: number): void {
    this.areaId = item
    this.getData()
  }

  // 切换排序
  changeSort (item: any): void {
    this.sortActive = item.sort
    this.sortType = item.sortType
    if (this.isDetail) {
      this.getScenicProductList()
      return
    }
    this.getData()
  }

  // 切换产品类目
  changeTreeId (): void {
    if (this.isDetail) {
      this.getScenicProductList()
      return
    }
    this.getData()
  }

  // 跳转景区详情
  clickView (item: any) {
    this.scenicItem = item
    this.isDetail = true
    this.getScenicProductList()
  }

  // 景区详情返回
  detailBack () {
    this.isDetail = false
  }

  mounted (): void {
    const { key, treeId, params, type, areaId } = this.$route.query
    if (typeof key === 'string') {
      this.keyword = key
    }
    if (treeId) {
      this.treeId = Number(treeId)
    }
    // 指定页面导航栏选项为节日，params 接口需要的数据isCommissionTop，isSalesTop，isFestivalPromo
    // /#/supermarket?params=isSalesTop
    if (params) {
      this.isTop = params
      this.TabActive = 0
      this.getHotSale(params)
    } else if (type) {
      // 指定页面导航栏选项 4产品总览 7商品 5港澳,港澳和海外可以额外指定地区参数areaId
      // /#/supermarket?type=5&areaId=10072
      this.TabActive = Number(type)
      this.changeTabs(Number(areaId))
    } else {
      this.getData()
    }
    this.getAdInfo()
    this.getTab()
  }
}
